export default __webpack_public_path__ + "static/media/about5.6bc9c12e.png";